export default {"src":"/_next/static/media/close-purple.e1b3deb1.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};